Object.defineProperty(exports, '__esModule', {
  value: true
});
var getAvatarInitials = function getAvatarInitials(label) {
  return ("" + label[0] + label[label.length - 1]).toUpperCase();
};
exports.getAvatarInitials = getAvatarInitials;